import { render, staticRenderFns } from "./demoicons.vue?vue&type=template&id=37d1a1c4&"
import script from "./demoicons.vue?vue&type=script&lang=js&"
export * from "./demoicons.vue?vue&type=script&lang=js&"
import style0 from "./demoicons.vue?vue&type=style&index=0&id=37d1a1c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports